import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Button,  ThemeProviderV2} from '@blueprint/ui';
import { useModal } from "react-modal-hook";
import { useHistory } from "react-router-dom";

import projectApi from "../../../api/project";
import { Loader, toast } from "../../../common/components/core";
import { useAuthErrorHandlerCreator } from "../../../common/hooks";
import { useSelector } from "../../../redux/hooks";
import { currentRolesSelector } from "../../../redux/slices/auth/selectors";
import { Handler } from "../../../types/common";
import {
    composeErrorHandlers,
    GenericError,
    onStaleStateError,
} from "../../../utils/errorHandling";
import { isUserContractor } from "../../../utils/role";

const useConfirmDeleteProjectHandler = (projectRef: string): Handler => {
    const history = useHistory();
    const [isSubmitting, setSubmitting] = useState(false);
    const onAuthError = useAuthErrorHandlerCreator();
    const currentRoles = useSelector(currentRolesSelector);

    const [show, hide] = useModal(() => {
        const confirm = async () => {
            setSubmitting(true);
            try {
                if (isUserContractor(currentRoles)) {
                    await projectApi.confirmDelete(projectRef);
                }
                history.push("/project");
            } catch (e) {
                setSubmitting(false);
                composeErrorHandlers(
                    onStaleStateError(() => {
                        history.push("/project");
                        toast("Page has been updated by another user.");
                    }),
                    onAuthError,
                )(e as GenericError);
            }
        };

        return (
            <ThemeProviderV2>
            <Modal show onHide={hide} backdrop="static" centered>
                <Loader overlay isLoading={isSubmitting}>
                    <Modal.Header>
                        <h2 className="mb-0">Project Deleted</h2>
                    </Modal.Header>
                    <Modal.Body>
                        <p>
                            This project was deleted by your project officer. If
                            you have any questions, please contact your project
                            officer.
                        </p>
                    </Modal.Body>

                    <Modal.Footer className="d-flex justify-content-end px-3">
                        <Button variant="light.primary" onClick={confirm}>
                            Dismiss
                        </Button>
                    </Modal.Footer>
                </Loader>
            </Modal>
            </ThemeProviderV2>
        );
    }, [projectRef, isSubmitting, onAuthError]);

    return {
        isSubmitting,
        handler: show,
    };
};

export default useConfirmDeleteProjectHandler;
